import { EnvironmentService } from '@core';
import { UploadConfig } from '@ntv360/component-pantry';

/**
 * Builds the uploader configuration at runtime using the EnvironmentService.
 *
 * This was previously a static constant, but now reads from runtime config
 * so API keys are never statically embedded in the JS bundle.
 */
export function getUploaderConfig(env: EnvironmentService): UploadConfig {
    return {
        provider: 'filestack',
        filestack: {
            apiKey: env.config.filestack.apiKey,
            videoOptimization: { width: 1280, height: 720 },
        },
    };
}
